/* eslint-disable import/no-cycle */
import * as API from './api';

const ClassroomModel = { ...API };

export default ClassroomModel;
